import * as React from 'react';
import { Typography, withStyles } from '@material-ui/core';
import styles from './styles';
import moment from 'moment';
import { showingTime, dotColor, splitShowings } from '../../../lib/helpers';

interface Props {
  classes: any;
  showings: any;
}

export class ShowingsColumn extends React.Component<Props> {
  renderUpComingShowings = (showings: any) => {
    const { classes } = this.props;
    return showings.map((showing: any, index: number) => {
      const date = moment(showing.date);
      const displayValue = `${date.format('MMM D')} @ ${showingTime(
        showing.date,
      )} `;

      return (
        <div key={index} className={classes.showingContentBox}>
          <div className={classes.showingDetailsFirstLine}>
            <div
              className={classes.showingStatusDot}
              style={{ backgroundColor: dotColor(showing) }}
            />
            <Typography className={classes.showingDate}>
              {displayValue}
            </Typography>
          </div>
          <Typography className={classes.showingAddress}>
            {showing.address}
          </Typography>
        </div>
      );
    });
  };
  render() {
    const { classes, showings } = this.props;
    // Extract only upcoming showings and openhouses
    const { upComingShowings, upComingOpenHouses } = splitShowings(showings);

    return (
      <div className={classes.upcomingShowingsBox}>
        {upComingShowings.length > 0 ? (
          <React.Fragment>
            <Typography
              className={classes.upcomingTitle}
              style={{ marginTop: 10 }}
            >
              Upcoming Tours
            </Typography>
            {this.renderUpComingShowings(upComingShowings)}
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        )}
        {upComingOpenHouses.length > 0 ? (
          <React.Fragment>
            <Typography
              className={classes.upcomingTitle}
              style={{ marginTop: 20 }}
            >
              Open Houses
            </Typography>
            {this.renderUpComingShowings(upComingOpenHouses)}
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(ShowingsColumn);
